import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { Link, useParams } from "react-router-dom";

import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";

import { lighten, makeStyles } from "@material-ui/core/styles";
import { format } from 'date-fns';
import DecimalsOnly from '../helpers/DemicalsOnly';
import Thousands from '../helpers/Thousands';
import AutoPayIcon from '@material-ui/icons/Autorenew';
import { Switch, CircularProgress } from '@material-ui/core';
import PaymentMethod from '../helpers/PaymentMethod';
import AutoPayModalDealer from '../components/AutoPayModalDealer';

import { 
    Button,
    Paper, 
    rgbToHex, 
    Tooltip,
    Modal,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
 } from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import HistoryIcon from "@material-ui/icons/HistoryOutlined";
import InfoIcon from '@material-ui/icons/InfoOutlined';

import axios from "axios";


import { Context as DealsContext } from "../context/deals.context.js";
import { Context as PortalContext } from "../context/portal.context.js";
import { Context as AuthContext } from "../context/auth.context.js";
import { delay } from "lodash";
import { datePickerDefaultProps } from "@material-ui/pickers/constants/prop-types.js";
import { fi, tr } from "date-fns/locale";


const qs = require("qs");


const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    paper: {
      width: "100%",
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
    historyButton: {
        alignSelf: "flex-end",
        height: 30,
        backgroundColor: "#004887",
        color: "white",
        borderRadius: 20,
        width: 100,
        marginBottom: 0,
        margin:10,
      },
    payButton: {
        marginTop: 15,
        height: 40,
        color: "white",
        borderRadius: 20,
        width: 150,
        marginBottom: 0,
      },
      dealPaymentContainers: {
		width: 800,
		height: 120,
		borderRadius: 5,
		backgroundColor: 'white',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		border: '1px solid #e3e6e7',
		marginTop: 15,
		padding: 15,
		boxSizing: 'border-box',
	},
    dealPaymentBox: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
    },
    dealPaymentBoxAmountInfo: {
        display: 'flex',
        flexDirection: 'row',
        fontWeight: '400',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginBottom: 10,
    },
    dividerContainer:{
        width: 1,
        height: '100%',
        background: '#e3e6e7',
    },
    yearText: {
		fontSize: 30,
		fontFamily: 'gotham-rounded-book,arial,helvetica,tahoma,verdana,sans-serif',
	},
    dealsContainer: {
        display: "flex",
        width: '40%',
        flexFlow: 'row wrap',
        boxShadow: '20px 0 21px -21px rgba(0,0,0,.14)',
        marginRight: 25,
    },
    dealDetails: {
        color: '#004887',
        fontSize: 14,
        display: 'flex',
        alignSelf: 'flex-start',
        marginBottom: -10,
        marginLeft: 5,
    },
    dueDate: {
        fontSize: 14,
        color: 'grey',
        display: 'flex',
        alignSelf: 'center',
        marginBottom: 15,
    },
  }));


export default function EnhancedTable(props) {
    const classes = useStyles();
    const authState = React.useContext(AuthContext);
    const portalState = React.useContext(PortalContext);
    


    const dealState = React.useContext(DealsContext);
    let { op } = useParams();

    console.log('AutoPay STATE', dealState.state.autoPay);

    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        console.log('rows per page', event.target.value);
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const columns = [
        { id: 'Date', label: 'Date', minWidth: 170 },
        { id: 'Amount', label: 'Amount', minWidth: 100 },
        { id: 'Method', label: 'Method', minWidth: 100 },
    ];


    const getLightbox = async ({
        buttonColor,
        customerID,
        merchantID,
        enpartialpayment,
      }) => {
        const options = {
          method: "POST",
          headers: {
            "content-type": "application/x-www-form-urlencoded",
          },
          data: qs.stringify({
            merchantID,
            customerID,
            method: "openLightbox",
            params: `{merchantID: ${merchantID}}`,
          }),
          withCredentials: true,
        };
    
        const intellipayResponse = await axios(options);
    
        // console.log('GET LIGHTBOX RESPONSE', intellipayResponse);
    
        if (document.getElementById("intellipay-lightbox") === null) {
          var rg = document.createRange();
          document.documentElement.appendChild(
            rg.createContextualFragment(intellipayResponse.data.lightbox)
          );
        }
    
        window.intellipay.initialize();
        window.intellipay.auth.enpartialpayment = enpartialpayment;
        window.intellipay.auth.isCustPortal = true;
        window.intellipay.auth.isFullAccount = authState.state.isFullAccount;
        window.intellipay.setItemLabel("account", "Account #");
        window.intellipay.enable("email");
        window.intellipay.setItemBackgroundColor("button", buttonColor);
    };

    const frequencyConversion = (frequency) => {
        switch(frequency){
            case 'B':
                return 'Bi-Weekly';
            case 'W':
                return 'Weekly';
            case 'S':
                return 'Semi';
            case 'M':
                return 'Monthly';
            default:
                return 'Monthly';
        }
    };

    const openLightBoxAndPayDeal = (deal) => {
        let dealAmount = 0;

        //check the contract amount due and add it to the total amount.
        if(
            deal.contractAmountDue > 0
        ){
            dealAmount += deal.contractAmountDue;
        }

        //make a copy of the transactions object to check if the payment has already been made.
        // once we use it remove it from the transaction object.
        var tranasctions = deal.transactions;
        var cleanUpdeferredDownDueDate = format(new Date(deal.deferredDownDueDate), 'MM/dd/yyyy');
    

        //If the deal has a deferred down payment and its the same year and month as the contract due date add it to the total amount.
        // check if the payment happened in the transaction object already.
        if(
            deal.deferredDownAmountDue > 0 &&
            (
                new Date(deal.deferredDownDueDate).getFullYear() == new Date(deal.contractDueDate).getFullYear() &&
                new Date(deal.deferredDownDueDate).getMonth() == new Date(deal.contractDueDate).getMonth() &&
                (
                    (   
                        JSON.stringify(tranasctions) != '{}' &&
                        tranasctions.filter((transaction) => transaction.Amount == deal.deferredDownAmountDue && ((typeof tranasctions.ApplyPaymentDate !== 'undefined' && tranasctions.ApplyPaymentDate == cleanUpdeferredDownDueDate) ||  (typeof tranasctions.ApplyPaymentDate === 'undefined' && transaction.Date == cleanUpdeferredDownDueDate))).length == false
                    ) || 
                    JSON.stringify(tranasctions) == '{}'
                )
            ) ||
            (
                new Date(deal.deferredDownDueDate) < new Date() &&
                (
                    (
                        JSON.stringify(tranasctions) != '{}' &&
                        tranasctions.filter((transaction) => transaction.Amount == deal.deferredDownAmountDue && ((typeof tranasctions.ApplyPaymentDate !== 'undefined' && tranasctions.ApplyPaymentDate == cleanUpdeferredDownDueDate) || ( typeof tranasctions.ApplyPaymentDate === 'undefined' && transaction.Date == cleanUpdeferredDownDueDate))).length == false
                    ) || 
                    JSON.stringify(tranasctions) == '{}'
                )
            )
        ){
            dealAmount += deal.deferredDownAmountDue;
        } else{
            //Check if the transaction object is not empty and if the transaction has already been made.
            //If the transaction has already been made remove it from the transaction object.
            if(
                JSON.stringify(tranasctions) != '{}' &&
                tranasctions.filter((transaction) => transaction.Amount == deal.deferredDownAmountDue && ((typeof tranasctions.ApplyPaymentDate !== 'undefined' && tranasctions.ApplyPaymentDate == cleanUpdeferredDownDueDate) || ( typeof tranasctions.ApplyPaymentDate === 'undefined' && transaction.Date == cleanUpdeferredDownDueDate))).length == true
            ){
                //found one so remove it from the transaction object.
                tranasctions = tranasctions.filter(function(el) { 
                    return el.Amount != deal.deferredDownAmountDue && 
                    (
                        (typeof el.ApplyPaymentDate !== 'undefined' && el.ApplyPaymentDate != cleanUpdeferredDownDueDate) ||
                        (typeof el.ApplyPaymentDate === 'undefined' && el.Date != cleanUpdeferredDownDueDate )
                    )
                });
            } 
        }

        

        //Need to add miscellaneous payments to the deal amount.
        if(
            deal.miscellaneousPayments &&
            deal.miscellaneousPayments.length > 0
        ){
            //loop through the miscellaneous payments and add them to the deal amount.
            deal.miscellaneousPayments.map((payment) => {
                if(
                    (
                        new Date(payment.DueDate).getFullYear() == new Date(deal.contractDueDate).getFullYear() &&
                        new Date(payment.DueDate).getMonth() == new Date(deal.contractDueDate).getMonth() &&
                        (
                            (
                                JSON.stringify(tranasctions) != '{}' &&
                                tranasctions.filter((transaction) => transaction.Amount == payment.Amount && ((typeof transaction.ApplyPaymentDate !== 'undefined' && transaction.ApplyPaymentDate == payment.DueDate) || (typeof transaction.ApplyPaymentDate === 'undefined' && transaction.Date == payment.DueDate))).length == false
                            ) || 
                            JSON.stringify(tranasctions) == '{}'
                        )
                    ) ||
                    (
                        new Date(payment.DueDate) < new Date() &&
                        (
                            (
                                JSON.stringify(tranasctions) != '{}' &&
                                tranasctions.filter((transaction) => transaction.Amount == payment.Amount && ((typeof transaction.ApplyPaymentDate !== 'undefined' && transaction.ApplyPaymentDate == payment.DueDate) || (typeof transaction.ApplyPaymentDate === 'undefined' && transaction.Date == payment.DueDate))).length == false
                            ) || 
                            JSON.stringify(tranasctions) == '{}'
                        )
                    )
                ){
                    dealAmount += payment.Amount;
                } else{
                    //Check if the transaction object is not empty and if the transaction has already been made.
                    //If the transaction has already been made remove it from the transaction object.
                    if(
                        JSON.stringify(tranasctions) != '{}' &&
                        tranasctions.filter((transaction) => transaction.Amount == payment.Amount && ((typeof transaction.ApplyPaymentDate !== 'undefined' && transaction.ApplyPaymentDate == payment.DueDate) || (typeof transaction.ApplyPaymentDate === 'undefined' && transaction.Date == payment.DueDate))).length == true
                    ){
                        //found one so remove it from the transaction object.
                        tranasctions = tranasctions.filter(function(el) { 
                            return el.Amount != payment.Amount && 
                            (
                                (typeof el.ApplyPaymentDate !== 'undefined' && el.ApplyPaymentDate != payment.DueDate) ||
                                (typeof el.ApplyPaymentDate === 'undefined' && el.Date != payment.DueDate)
                            )
                        });
                    } 

                }
            })

        }

        //If the deal has a side note payment and its the same year and month as the contract due date add it to the total amount.
        // check if the payment happened in the transaction object already.
        if(
            deal.sideNoteAmountDue > 0 &&
            (
                new Date(deal.sideNoteDueDate).getFullYear() == new Date(deal.contractDueDate).getFullYear() &&
                new Date(deal.sideNoteDueDate).getMonth() == new Date(deal.contractDueDate).getMonth() && 
                (
                    (
                        JSON.stringify(tranasctions) != '{}' &&
                        tranasctions.filter((transaction) => transaction.Amount == deal.sideNoteAmountDue && ((transaction.ApplyPaymentDate !== 'undefined' && transaction.ApplyPaymentDate == deal.sideNoteDueDate) || (transaction.ApplyPaymentDate === 'undefined' && transaction.Date == deal.sideNoteDueDate))).length == false
                    ) ||
                    JSON.stringify(tranasctions) == '{}'
                )
            ) ||
            (
                new Date(deal.sideNoteDueDate) < new Date() &&
                (
                    (
                        (
                        JSON.stringify(tranasctions) != '{}' &&
                        tranasctions.filter((transaction) => transaction.Amount == deal.sideNoteAmountDue && ((transaction.ApplyPaymentDate !== 'undefined' && transaction.ApplyPaymentDate == deal.sideNoteDueDate) || (transaction.ApplyPaymentDate === 'undefined' && transaction.Date == deal.sideNoteDueDate))).length == false
                    ) ||
                        JSON.stringify(tranasctions) == '{}'
                    )
                )
            )
        ){
            dealAmount += deal.sideNoteAmountDue;
        } else{
            //Check if the transaction object is not empty and if the transaction has already been made.
            //If the transaction has already been made remove it from the transaction object.
            if(
                JSON.stringify(tranasctions) != '{}' &&
                tranasctions.filter((transaction) => transaction.Amount == deal.sideNoteAmountDue && ((transaction.ApplyPaymentDate !== 'undefined' && transaction.ApplyPaymentDate == deal.sideNoteDueDate) || (transaction.ApplyPaymentDate === 'undefined' && transaction.Date == deal.sideNoteDueDate))).length == true
            ){
                //found one so remove it from the transaction object.
                tranasctions = tranasctions.filter(function(el) { 
                    return el.Amount != deal.sideNoteAmountDue && 
                    (
                        (typeof el.ApplyPaymentDate !== 'undefined' && el.ApplyPaymentDate != deal.sideNoteDueDate) ||
                        (typeof el.ApplyPaymentDate === 'undefined' && el.Date != deal.sideNoteDueDate)
                    )
                });
            }
        }


        // Set that values before opening the lightbox
        setLightboxAmount(dealAmount);
        setLightboxAccount(deal.accountNumber);
        setLightboxInvoice(deal.dealId);

        //add a slight delay to ensure the lightbox is fully loaded before submitting.
        setTimeout(() => {
            window.intellipay.onSubmit();
        })
    }


    const [lightboxAmount, setLightboxAmount] = React.useState(0);
    const [lightboxAccount, setLightboxAccount] = React.useState('');
    const [lightboxInvoice, setLightboxInvoice] = React.useState('');
    const [dealershipTransactionsHistoryDetails, setDealershipTransactionsHistoryDetails] = React.useState(false);


    const dealershipTransactionsHistoryDetailsOpen = () => {
        setDealershipTransactionsHistoryDetails(true);
    };

    const handleClose = () => {
        setDealershipTransactionsHistoryDetails(false);
    };

    const {
        state,
        getDeals,
        getAutoPay,
        updateAutoPay,
        setAutoPayModalOpen,
        setSelectedDeal,
    } = React.useContext(DealsContext);

    useEffect(() => {
        getDeals({
            merchantID: authState.state.merchantID,
            customerID: authState.state.customerID,
        });

        getAutoPay({
            customerID: authState.state.customerID,
            merchantID: authState.state.merchantID,
        });

        getLightbox({
            buttonColor: props.theme.palette.secondary.main,
            customerID: authState.state.customerID,
            merchantID: authState.state.merchantID,
            enpartialpayment: portalState.state.allowPartialPayment,
        });

    }, [authState.state.authenticated]);

    




  return (
    <>

        {/* Inputs are used for popluating the lightbox with data. Popluate before opening the lightbox. */}
        <input
            className="ipayfield"
            id="intellipay-amount-hidden"
            data-ipayname="amount"
            type="hidden"
            value={parseFloat(lightboxAmount).toFixed(2)}
        />
        <input
            className="ipayfield"
            data-ipayname="account"
            type="hidden"
            value={ lightboxAccount }
        />

        <input
            className="ipayfield"
            data-ipayname="invoice"
            type="hidden"
            value={lightboxInvoice}
        />

        {/* End of input section. */}


        <div 
            className="content-wrapper"
            style={{
                display: "flex",
                boxSizing: "border-box",
                padding: 15,
            }}
        >


            {authState.state.isFullAccount && portalState.state.allowAutoPay ? (
                <>
                    <div className="autoPayDealerContainer">
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%',
                            }}
                        >
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                    
                                <h3
                                    style={{
                                        color: '#2f343b',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        marginTop: 0,
                                        marginBottom: 0,
                                        fontWeight: 500,
                                    }}
                                >
                                    <x-lang>Auto Pay</x-lang>
                                </h3>
                            </div>

                            <Switch
                                checked={dealState.state.autoPay.autoPayEnabled}
                                onChange={() => {
                                    if (
                                        dealState.state.autoPay.autoPayEnabled
                                    ) {
                                        updateAutoPay({
                                            paymentMethod:
                                            dealState.state.autoPay
                                                    .paymentMethod === 'ach'
                                                    ? 'ACH'
                                                    : 'CC',
                                            state: 'off',
                                        });
                                    } else {
                                        setAutoPayModalOpen(true);
                                    }
                                }}
                                color="secondary"
                                name="checkedB"
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                        </div>
                        {dealState.state.autoPay.autoPayEnabled ? (
                            <div
                                style={{
                                    marginTop: 25,
                                    width: '100%',
                                    marginLeft: isTabletOrMobile ? 25 : 45,
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'flex-start',
                                        justifyContent: 'flex-start',
                                        width: '100%',
                                        marginBottom: 20,
                                    }}
                                >
                                    <span
                                        style={{
                                            marginBottom: 8,
                                            color: '#627278',
                                        }}
                                    >
                                        <x-lang>Payment Method</x-lang>
                                    </span>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                        }}
                                    >
                                        {PaymentMethod(
                                            dealState.state.autoPay
                                                .paymentMethod
                                        )}
                                        <span style={{ marginLeft: 10 }}>
                                        <x-lang>ending in</x-lang> ...
                                            {
                                                dealState.state.autoPay
                                                    .paymentLastFour
                                            }
                                        </span>
                                    </div>

                                    {dealState.state.autoPay.autoPaySettings.autopay_start_date != '' && dealState.state.autoPay.autoPaySettings.autopay_start_date != null && (
                                        <span className="autoPayDealerText">
                                            <x-lang>Start Date:{format(new Date(dealState.state.autoPay.autoPaySettings.autopay_start_date), 'MM/dd/yyyy')}</x-lang>
                                        </span>
                                    )}
                                    {dealState.state.autoPay.autoPaySettings.autopay_reminder_days != '' && dealState.state.autoPay.autoPaySettings.autopay_reminder_days != null && (
                                        <span className="autoPayDealerText">
                                            <x-lang>Reminder Days:{dealState.state.autoPay.autoPaySettings.autopay_reminder_days}</x-lang>
                                        </span>
                                    )}
                                    {dealState.state.autoPay.autoPaySettings.autopay_max_amount != '' && dealState.state.autoPay.autoPaySettings.autopay_max_amount != null && (
                                        <span className="autoPayDealerText">
                                            <x-lang>Max Amount:{dealState.state.autoPay.autoPaySettings.autopay_max_amount}</x-lang>
                                        </span>
                                    )}
                                    {dealState.state.autoPay.autoPaySettings.autopay_amount_override != '' && dealState.state.autoPay.autoPaySettings.autopay_amount_override != null && (
                                        <span className="autoPayDealerText">
                                            <x-lang>Amount Override:{dealState.state.autoPay.autoPaySettings.autopay_amount_override}</x-lang>
                                        </span>
                                    )}
                                    {dealState.state.autoPay.autoPaySettings.autopay_pay_advance_days != '' && dealState.state.autoPay.autoPaySettings.autopay_pay_advance_days != null && (
                                        <span className="autoPayDealerText">
                                            <x-lang>Pay Advance Days:{dealState.state.autoPay.autoPaySettings.autopay_pay_advance_days}</x-lang>
                                        </span>
                                    )}
                                    {dealState.state.autoPay.autoPaySettings.autopay_pay_day_of_month != '' && dealState.state.autoPay.autoPaySettings.autopay_pay_day_of_month != null && (
                                        <span className="autoPayDealerText">
                                            <x-lang>Pay Day of Month:{dealState.state.autoPay.autoPaySettings.autopay_pay_day_of_month}</x-lang>
                                        </span>
                                    )}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </>
            ) : null}
            {dealState.state.autoPayModalOpen ? <AutoPayModalDealer /> : null}



            <div className="deals-container" >

                {dealState.state.deals.map((row) => ( 
                    <>
                        <div 
                            className="deal-section"
                        >

                            <div className="deals-account-wrapper">
                                <div 
                                    className="deals-account-details"
                                >
                                    <h5 style={{color:'grey'}} className="deal-details">
                                        {row.dealId}
                                    </h5>
                                    <h5 className="deal-details">
                                        <x-lang>Account: </x-lang> {row.accountNumber}
                                    </h5>
                                    <h5 style={{marginBottom:5}} className="deal-details">
                                        {row.vehicleMake} {row.vehicleModel} ({row.vin})
                                    </h5>
                    

                                </div>
                                <div style={{ width: '25%'}}>
                                    <Button
                                        variant={"contained"}
                                        color="primary"
                                        disableElevation
                                        disabled={(dealState.state.selectedDeal.id == row.id) ? true: false}
                                        className="deal-history-button"
                                        onClick={() => setSelectedDeal(row)}
                                    >
                                        { isTabletOrMobile && ( <HistoryIcon /> )}
                                        { !isTabletOrMobile && ( <x-lang>History</x-lang> )}
                                    </Button>
                                </div>
                            </div>


                        
                            <div
                                style={{
                                    width: '100%',
                                    display: "flex",
                                    boxSizing: "border-box",
                                }}
                            >
                                <div className="deal-payment-containers">
                                    <div className="deal-payment-box">

                                    <div className="deal-paymentbox-amount-info">
                                                <sup style={{ fontSize: 18 }}>$</sup>
                                                <span className="year-text" >
                                                    {Thousands(Math.trunc(row.contractAmountDue))}
                                                </span>
                                                <sup style={{ fontSize: 18 }}>
                                                    {DecimalsOnly(row.contractAmountDue)}
                                                </sup>

                                        </div>
                                        
                                        <span className="label-text"><x-lang>Contract Amount</x-lang></span>
                                        <span className="label-text"><x-lang>Frequency</x-lang></span>
                                        <span className="label-text"><x-lang>{frequencyConversion(row.contractPaymentFrequency)}</x-lang>{ row.contractPaymentFrequency == 'S' &&  (<span className="label-text"><x-lang>{'(' +row.semiMonthlyDay1 + ', ' + row.semiMonthlyDay2 + ')'}</x-lang></span> )}</span>
                                        
                                        <span className="due-date">
                                            <x-lang>Due</x-lang>: {format(new Date(row.contractDueDate), 'MM/dd/yyyy')}
                                        </span>
                                    </div>


                                    { row.sideNoteAmountDue > 0 && (
                                        <>
                                            <div className={classes.dividerContainer}></div>
                                            
                                            <div className="deal-payment-box">
                                                <div className="deal-paymentbox-amount-info">
                                                        <sup style={{ fontSize: 18 }}>$</sup>
                                                        <span className="year-text" >
                                                            {Thousands(Math.trunc(row.sideNoteAmountDue))}
                                                        </span>
                                                        <sup style={{ fontSize: 18 }}>
                                                            {DecimalsOnly(row.sideNoteAmountDue)}
                                                        </sup>

                                                </div>
                                                <span className="label-text"><x-lang>Side Note Amount</x-lang></span>
                                                <span className="due-date">
                                                    <x-lang>Due</x-lang>: {format(new Date(row.sideNoteDueDate), 'MM/dd/yyyy')}
                                                </span>
                                            </div>
                                        </>
                                    )}
                                    
                                    {
                                        //Check for miscellaneous payments and loop through showing them.
                                        row.miscellaneousPayments && row.miscellaneousPayments.length > 0 && (
                                            <>
                                                { row.miscellaneousPayments.map((payment) => (
                                                    <>
                                                    <div className={classes.dividerContainer}></div>
                                                    
                                                    <div className="deal-payment-box">
                                                        <div className="deal-paymentbox-amount-info">
                                                            <sup style={{ fontSize: 18 }}>$</sup>
                                                            <span className="year-text" >
                                                                {Thousands(Math.trunc(payment.Amount))}
                                                            </span>
                                                            <sup style={{ fontSize: 18 }}>
                                                                {DecimalsOnly(payment.Amount)}
                                                            </sup>

                                                        </div>
                                                        <span className="label-text"><x-lang>{payment.Label}</x-lang></span>

                                               

                                                        <span className="due-date">
                                                            <x-lang>Due: </x-lang>
                                                            <x-lang>{format(new Date(payment.DueDate), 'MM/dd/yyyy')}</x-lang>
                                                        </span>

                                                    </div>
                                                    </>
                                                ))}
                                            </>
                                        )
                                    }


                                    { row.deferredDownAmountDue > 0 && (
                                        <>
                                            <div className={classes.dividerContainer}></div>
                                            <div className="deal-payment-box">
                                                <div className="deal-paymentbox-amount-info">
                                                        <sup style={{ fontSize: 18 }}>$</sup>
                                                        <span className="year-text" >
                                                            {Thousands(Math.trunc(row.deferredDownAmountDue))}
                                                        </span>
                                                        <sup style={{ fontSize: 18 }}>
                                                            {DecimalsOnly(row.deferredDownAmountDue)}
                                                        </sup>

                                                </div>
                                                <span className="label-text"><x-lang>Deferred Down</x-lang></span>
                                                <span className="due-date">
                                                    <x-lang>Due</x-lang>: {format(new Date(row.deferredDownDueDate), 'MM/dd/yyyy')}
                                                </span>
                                            </div>
                                        </>
                                    )}

                                </div>

                            </div>

                            <div>

                                <Button
                                    variant={"contained"}
                                    color="primary"
                                    className={classes.payButton}
                                    disabled={(row.lockAccount) ? true: false}
                                    //onClick={props.handleOpen}
                                    onClick={() => openLightBoxAndPayDeal(row)}
                                >
                                    <x-lang>{(row.lockAccount) ? 'Locked': 'Pay Now'} </x-lang>
                                </Button>
                            </div>
                        </div>

                    </>
                ))}
            </div>


            {/* Before showing transaction history for the deal ensure that a deal has been selected. */}
            { 
                dealState.state.deals.length >= 1 &&
                dealState.state.selectedDeal !== null && 
                dealState.state.selectedDeal != {} && 
                dealState.state.selectedDeal.transactions && 
            (
                <>
                    <Paper
                        className={classes.paper}
                        elevation={0}
                        style={{
                            width: '100%',
                            marginTop: 25,
                            boxSizing: 'border-box',
                            border: '1px solid #e3e6e7',
                            marginBottom: 0,
                        }}
                    >
                        <Toolbar
                        className={clsx(classes.root)}
                        style={{
                            display: "flex",
                            width: "auto",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            height: 85,
                            paddingLeft: 25,
                            paddingRight: 25,
                        }}
                        >
                            
                        <Typography
                            variant="h6"
                            id="tableTitle"
                            component="div"
                            style={{ color: props.theme.palette.primary.main }}
                        >

                            <x-lang>Dealership Transactions History</x-lang>

                            <Tooltip 
                                title="Dealer Transaction History is updated by the dealer and may not reflect the most recent transactions.To see all transactions within the customer portal go to the history tab."
                            >
                                <Button onClick={dealershipTransactionsHistoryDetailsOpen}>
                                    <InfoIcon />
                                </Button>
                            </Tooltip>

                            <Dialog
                                open={dealershipTransactionsHistoryDetails}
                                
                                onClose={handleClose}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                >
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <x-lang>Dealer Transaction History is updated by the dealer and may not reflect the most recent transactions.To see all transactions within the customer portal go to the history tab. </x-lang>
                                        {!authState.state.isFullAccount && ( "Return to the login page to create an account." )}
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose} color="primary">
                                    <x-lang>Close</x-lang>
                                    </Button>
                                </DialogActions>
                            </Dialog>

                        </Typography>
                        <Typography
                            className="label-text"
                            style={{ color: "grey" }}
                        >
                            <x-lang>{dealState.state.selectedDeal.vehicleMake + ' ' + dealState.state.selectedDeal.vehicleModel}</x-lang>
                        </Typography>
                        </Toolbar>

                        <TableContainer
                            style={{
                                paddingLeft: 25,
                                paddingRight: 25,
                                boxSizing: 'border-box',
                            }}
                        >
                            <Table 
                                className={classes.table}
                                aria-labelledby="tableTitle"
                                // size={dense ? 'small' : 'medium'}
                                aria-label="enhanced table"
                            >
                            <caption>{dealState.state.selectedDeal.accountNumber} tranasction history</caption>
                            <TableHead
                                style={{
                                backgroundColor: "rgb(236, 241, 246)",
                                }}
                            >
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                        >
                                        {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dealState.state.selectedDeal.transactions.length >= 1 ? dealState.state.selectedDeal.transactions
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={Math.random()}>
                                        {columns.map((column) => {
                                        const value = row[column.id];
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                            {column.format && typeof value === 'number'
                                                ? column.format(value)
                                                : value}
                                            </TableCell>
                                        );
                                        })}
                                    </TableRow>
                                    );
                                }) : 'No transactions found for this deal.'}
                                {/* {dealState.state.selectedDeal.transactions.length >=1 ? dealState.state.selectedDeal.transactions.map((row) => (
                                <TableRow>
                                    <TableCell>{row.Date}</TableCell>
                                    <TableCell align="right">{row.Amount}</TableCell>
                                    <TableCell align="right">{row.Method}</TableCell>
                                </TableRow>
                                )): 'No transactions found for this deal.'} */}
                            </TableBody>
                            </Table>
                        </TableContainer>
                        {dealState.state.selectedDeal.transactions.length >= 1 ?
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 15]}
                                component="div"
                                count={dealState.state.selectedDeal.transactions ? dealState.state.selectedDeal.transactions.length : 0}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        : null }

                        <div style={{
                                fontSize: 12,
                                color: "grey",
                                display: 'flex',
                                flexDirection: 'column',
                                textAlign: 'center',
                                marginTop: 15,
                                width: '72%',
                        }}>
                            
                        </div>
                    </Paper>
        
                </>
            )}
        </div>
    </>
  );
}
